<template>
    <div v-bind:class="['shirt-designer', (is_touch_device ? 'touch-enabled' : 'touch-disabled') ]" id="konfigurator">
        <!-- component changes when vm.currentview changes! -->
        <div class="preview-col">
            <div class="top-step-name mobile basic-border basic-color">{{{ currentStep }}}<span class="extra_price"
                                                                                                v-bind:style="[(currentPrice !== '' ? {visibility: 'visible'} : {visibility: 'hidden'})]"> + {{ currentPrice }} €</span>
            </div>
            <div class="sticky-wrapper">
                <div v-if="count < (views.length-1)" class="designer-content-col" id="shirtpreview">

                    <div class="designer-img-shirt ">
                        <img v-if="false" class="img-blocker" v-bind:src="invurl"/>
                        <img v-if="personal['monogramm'] !== '' && personal['monogramm'] !== 'no_monogramm'"
                             class="img-monogramm" v-bind:src="monogrammUrl"/>
                        <img v-if="personal['front'] !== 'hidden'" class="img-buttons-front"
                             v-bind:src="buttonsFrontUrl"/>
                        <img v-if="personal['sleeve']!== 'short' && personal['sleeve']!='shortbar'"
                             class="img-buttons-cuff" v-bind:src="buttonsCuffUrl"/>
                        <div v-bind:class="['collar-container', personal['collar'] ]">
                            <img class="img-buttons-collar" v-bind:src="buttonsCollarUrl"/>
                            <img v-if="personal['yarnbuttonhole'] !== 'neutral'" class="img-yarn-collar" v-bind:src="yarnCollarUrl"/>
                            <img class="img-collar-wings" v-bind:src="collarWingsUrl"/>
                            <img class="img-collar-stand" v-bind:src="collarStandUrl"/>
                            <img class="img-collar-innerback" v-bind:src="collarInnerBackUrl"/>
                            <img v-bind:class="['img-collar-innerstand', personal['collar'] ]"
                                 v-bind:src="collarInnerStandUrl"/>
                        </div>
                        <img v-if="personal['front'] === 'hidden' && personal['yarnbuttonhole'] !== 'neutral'" class="img-yarn-front" v-bind:src="yarnFrontUrl"/>
                        <img v-if="personal['sleeve']!='short' && personal['sleeve']!='shortbar' && personal['yarnbuttonhole'] !== 'neutral'" class="img-yarn-cuff"
                             v-bind:src="yarnCuffUrl"/>
                        <img v-if="personal['front'] === 'sewed'" class="img-front" v-bind:src="frontUrl"/>
                        <img v-if="personal['contrast_bs_upper_outside'] !== 'none'" class="img-button-stripe"
                             v-bind:src="buttonStripeUrl"/>
                        <img v-if="personal['bags'] !== 'none'" class="img-bags" v-bind:src="bagsUrl"/>
                        <img v-if="personal['sleeve']!== 'short' && personal['sleeve']!='shortbar'" class="img-cuff"
                             v-bind:src="cuffUrl"/>
                        <img v-if="personal['sleeve']!== 'short' && personal['sleeve']!='shortbar'"
                             class="img-cuff-inner" v-bind:src="cuffInnerUrl"/>
                        <img class="img-sleeve" v-bind:src="sleeveUrl"/>
                        <img class="img-fit" v-bind:id="personal['fabric']" v-bind:src="fitUrl"/>
                    </div>

                    <div class="designer-imgtopbot-box">
                        <p class="tax-details"><span class="tax-details">{{{ imgcaption }}}</span></p>
                    </div>
                </div>

                <div v-if="count >= (views.length-1)" class="designer-content-col-mid">
                    <div class="designer-attributesbox">

                        <div v-if="isloggedin === 'false'" class='login'>
                            <p style="clear: both;">Bitte melden Sie sich an, um Ihr Maßprofil auswählen zu können.</p>
                            {{{ measurementblock }}}
                        </div>

                        <div v-if="isloggedin === 'true'" class="tocart">
                            <h4 v-if="measurementblock.length > 1">Eigenes Maßprofil wählen</h4>
                            <p v-if="measurementblock.length > 1">Wenn Sie bereits ein Maßprofil hinterlegt haben oder
                                eine Anfertigung nach
                                Konfektionsmaßen wünschen, können Sie hier Ihr Wunschprofil auswählen.</p>
                            <h4 v-if="measurementblock.length <= 1">Eigenes Maßprofil erstellen</h4>
                            <p v-if="measurementblock.length <= 1">Erstellen Sie jetzt in wenigen Schritten Ihr
                                individuelles Maßprofil.</p>
                            <div class="designer-select">
                                <a href="{{ measurementUrl }}">
                                    <button class="button" title="{{ translations['Create mesurement profile'] }}"
                                            type="button">
                                        <span>{{ translations['Create mesurement profile'] }}</span>
                                    </button>
                                </a>
                                <select v-if="measurementblock.length > 1" name="setMeasurement"
                                        id="shirtdesigner-measurement-select"
                                        class="designer-measurement-select" title="" @change="addToCart">
                                    <option v-for="option in measurementblock" :value="option.value">{{ option.label
                                        }}
                                    </option>
                                </select>
                            </div>
                            <a id="ajax_events_cart" href=""></a>
                            <div v-if="selectItems">
                                <form :action="selectItems.checkoutUrl" method="post" id="product_addtocart_form"
                                      enctype="multipart/form-data">
                                    <button id="tocart" class="button" title="In den Warenkorb" type="button"
                                            @click="clearViewCount">
                                        <span>{{ addToCartText }}</span>
                                    </button>
                                    <!-- Generate HIDDEN FIELDS -->
                                    <input v-for="item in selectItems.shirt" type="text"
                                           class="input-text required-entry product-custom-option"
                                           :name="'options['+item.id+']'" :id="$key" :value="item.val"
                                           style="display:none;">
                                    <input v-for="item in selectItems.tab" v-if="item.data.length" type="text"
                                           class="input-text required-entry product-custom-option"
                                           :name="'options['+item.id+']'" :id="$key" :value="item.data"
                                           style="display:none;">
                                </form>
                                <button class="button summary" title="Bestelldetails" type="button"
                                        @click="showSummary">
                                    <span>Bestelldetails</span>
                                </button>
                            </div>
                        </div>

                    </div>

                    <div class="designer-detailbox" id="addtocart-form-container">
                        <div class="designer-detailbox-picture" style="display:none;">
                            <a id="ajax_default" href=""></a>
                        </div>

                    </div>
                </div>


            </div>
            <div style="clear:both"></div>
        </div>

        <component
                :is="currentView"
                :fabrics="fabrics"
                :items="selectItems"
                :box="selectBox"
                :zoom="zoom"
                :show.sync="showModal"
                :personal="personal"
                :muster1="muster1"
                :muster2="muster2"
                :muster3="muster3"
                :muster4="muster4"
                :isactive="isActive"
                :baseurl="baseurl"
                :translations="translations"
                :buttonsection="buttonsection">
        </component>

        <!-- //RIGHT INFO BOX -->

        <div class="infobox">
            <div class="nav-btn-box">
                <button @click="prevStep" type="button" class="prev-btn basic-bg" v-on:touchstart="touchhover"
                        v-on:touchend="touchhoverout" id="designer_main_back">zurück
                </button>
                <button v-if="count < (views.length-1)" @click="nextStep" class="next-btn basic-bg" type='button'
                        v-on:touchstart="touchhover" v-on:touchend="touchhoverout" id="designer_main_forward">
                    weiter
                </button>
                <button v-if="count < (views.length-1)" @click="gotoStep(views.length-1)" class="checkout-btn"
                        type='button'>Jetzt Kaufen
                </button>
            </div>
            <div class="price basic-color">
                <div class="designer-price-box">

                    <span class="cprice">{{ price }} &euro;</span>
                    <span class="tax-details">{{{ priceInfo }}}</span>
                </div>
            </div>
            <div class="design-name">
                <div class="design-label">Design:</div>
                <input class="input-text" type="search" id="design-name" maxlength="36" name="design-name"
                       v-model="designName"/>
                <button type="button" class="save-design basic-bg" @click="saveDesign">speichern</button>
                <button type="button" class="cancel-design" @click="resetConfig">zurücksetzen</button>
                <div style="display: none"
                     v-bind:class="'design-name msg ' + (msg.error ? 'error' : 'success')" id="messages">
                    <a v-if="msg.error" v-bind:href="loginurl">{{ msg.error }}</a> {{ msg.success
                    }}
                </div>
            </div>
            <div class="step">
                <ul id="steps">
                    <li v-for="(index, step) in steps" v-if="index !== 14" @click='gotoStep(index)'
                        v-bind:class="[ (selectBoxes[views[index]].active ? 'step-enabled' : 'step-disabled') ]">
                        <span class="edit-icon"></span>
                        <span v-bind:id='index'
                              v-bind:class="[ 'step-name', (index === count ? 'active' : '' )]">{{ step }}</span>
                    </li>
                </ul>
                <span class="username"></span>
            </div>
        </div>
        <div v-show="flash.error || flash.success"
             v-bind:class="[ 'fabric-sample-popup', 'basic-bg', (flash.success ? 'flash-success' : 'flash-error')]"
             id="flash">
            <div class="text-icon">
                <span class="icon"></span>
                <div class="text">{{ flash.error }} {{ flash.success }}</div>
                <span class="link"><a href="/shop/accessoires/stoffmuster-bestellen" target="_blank">{{ translations['To swatch box'] }}</a></span>
            </div>
        </div>
    </div>
    <div v-if="count < (views.length-1)" class="sticky-wrapper">
        <div class="category-description std designer-description">{{{ seoblock }}}</div>
    </div>
</template>

<script>
var jQuery = require('jquery')

import Fabric from './components/Fabric'
import Buttons from './components/Buttons'
import Fit from './components/Fit'
import Collar from './components/Collar'
import Cuff from './components/Cuff'
import Bags from './components/Bags'
import Monogramm from './components/Monogramm'
import Hankerchief from './components/Hankerchief'
import Yarnbuttonhole from './components/Yarnbuttonhole'
import Contrastjumper from './components/Contrastjumper'
import ContrastCollarOutside from './components/ContrastCollarOutside.vue'
import Checkout from './components/Checkout'

export default {
  components: {
    Fabric,
    Buttons,
    Fit,
    Collar,
    Cuff,
    Bags,
    Monogramm,
    Hankerchief,
    Yarnbuttonhole,
    Contrastjumper,
    ContrastCollarOutside,
    Checkout
  },
  data: function () {
    return {
      is_touch_device: 'ontouchstart' in window || navigator.maxTouchPoints,
      currentView: 'fabric',
      count: 0,
      msg: Object,
      flash: Object,
      priceExtra: '9.90',
      session: Object,
      buttonPrice: 0,
      buttonsection: 1,
      buttons: [],
      loginurl: window.shirtdesigner.loginurl,
      price: window.shirtdesigner['priceClassic'],
      priceInfo: window.shirtdesigner.priceInfo,
      baseurl: window.shirtdesigner['baseurl'],
      measurementUrl: window.shirtdesigner['measurementUrl'],
      invurl: window.shirtdesigner.invurl,
      isloggedin: window.shirtdesigner.loggedin,
      measurementblock: window.shirtdesigner.measurementblock,
      imgcaption: window.shirtdesigner.translations.imgcaption,
      seoblock: window.shirtdesigner.translations.seoBlock,
      addToCartText: window.shirtdesigner.translations['Add to Cart'],
      translations: window.shirtdesigner.translations,
      views: ['fabric', 'fit', 'lowercut', 'sleeve', 'collar', 'cuff', 'buttons', 'front', 'back', 'bags', 'monogramm', 'hankerchief', 'yarncontrast', 'yarnbuttonhole', 'contrastjumper', 'contrast_bs_upper_outside', 'contrast_bs_upper_inside', 'contrast_bs_bottom_outside', 'contrast_collar_outside', 'contrast_collar_bottom', 'contrast_collar_stand_outer', 'contrast_collar_stand_inner', 'contrast_cuff_outside', 'contrast_cuff_inside', 'contrast_sleeve_buttons_outside', 'contrast_sleeve_buttons_inside', 'checkout'],
      personal: { 'fabric': 'Twill-1', 'fabric_quality': 'classic', 'fit': 'normal', 'lowercut': 'curved', 'sleeve': 'long', 'collar': 'kent', 'collarbuttons': 'onebutton', 'collar_height': '4', 'collar_strength': 'solid', 'cuff': 'squaresingle', 'cuffwidth': '', 'front': 'normal', 'buttons': 'button_01', 'button-color': 'default', 'bags': 'none', 'bagsposition': 'left', 'back': 'flat', 'monogramm': 'no_monogramm', 'monopos': 'waistleft', 'monogramm_yarn': 'neutral', 'monogramm_font': 'block', 'monogramm-color': '000000', 'yarn-color': 'neutral', 'yarncontrast': 'neutral', 'yarnbuttonhole': 'neutral', 'contrast_collar_outside': 'none', 'contrast_collar_bottom': 'none', 'contrast_collar_stand_outer': 'none', 'contrast_collar_stand_inner': 'none', 'contrast_cuff_outside': 'none', 'contrast_cuff_inside': 'none', 'hankerchief': 'none', 'tj_logo': 'yes', 'outsize': 'none', 'contrast_sleeve_buttons_outside': 'none', 'contrast_sleeve_buttons_inside': 'none', 'contrast_bs_upper_outside': 'none', 'contrast_bs_upper_inside': 'none', 'contrast_bs_bottom_outside': 'none', 'topseller': '0', 'configure_id': '0' },
      defaults: { 'fabric': 'Twill-1', 'fabric_quality': 'classic', 'fit': 'normal', 'lowercut': 'curved', 'sleeve': 'long', 'collar': 'kent', 'collarbuttons': 'onebutton', 'collar_height': '4', 'collar_strength': 'solid', 'cuff': 'squaresingle', 'cuffwidth': '', 'front': 'normal', 'buttons': 'button_01', 'button-color': 'default', 'bags': 'none', 'bagsposition': 'left', 'back': 'flat', 'monogramm': 'no_monogramm', 'monopos': 'waistleft', 'monogramm_yarn': 'neutral', 'monogramm_font': 'block', 'monogramm-color': '000000', 'yarn-color': 'neutral', 'yarncontrast': 'neutral', 'yarnbuttonhole': 'neutral', 'contrast_collar_outside': 'none', 'contrast_collar_bottom': 'none', 'contrast_collar_stand_outer': 'none', 'contrast_collar_stand_inner': 'none', 'contrast_cuff_outside': 'none', 'contrast_cuff_inside': 'none', 'hankerchief': 'none', 'tj_logo': 'yes', 'outsize': 'none', 'contrast_sleeve_buttons_outside': 'none', 'contrast_sleeve_buttons_inside': 'none', 'contrast_bs_upper_outside': 'none', 'contrast_bs_upper_inside': 'none', 'contrast_bs_bottom_outside': 'none', 'topseller': '0', 'configure_id': '0' },
      steps: ['Stoff'],
      fabrics: [],
      designName: 'Mein Design',
      design: [],
      designId: window.shirtdesigner.designId,
      selectItems: [],
      selectBox: [],
      zoom: { img: '', title: '', text: '', price: '' },
      stepValue: [],
      sleevesShort: false,
      selectBoxes: {
        'fit': { 'component': 'fit', 'title': window.shirtdesigner.translations['Fit'], 'todo': window.shirtdesigner.translations['Choose the correct fit'], 'active': true },
        'lowercut': { 'component': 'lowercut', 'title': window.shirtdesigner.translations['Lower Cut'], 'todo': window.shirtdesigner.translations['Choose the lower cut'], 'active': true },
        'sleeve': { 'component': 'sleeve', 'title': window.shirtdesigner.translations['Sleeve'], 'todo': window.shirtdesigner.translations['Choose a sleeve form'], 'active': true },
        'collar': { 'component': 'collar', 'title': window.shirtdesigner.translations['Collar'], 'todo': window.shirtdesigner.translations['Choose a collar type'] + ' ' + window.shirtdesigner.translations['You can choose between number of collar buttons, collar height and strength.'], 'active': true },
        'cuff': { 'component': 'cuff', 'title': window.shirtdesigner.translations['Cuff'], 'todo': window.shirtdesigner.translations['Choose a cuff type'], 'active': true },
        'buttons': { 'component': 'buttons', 'extra': '0,00', 'title': window.shirtdesigner.translations['Buttons'], 'todo': window.shirtdesigner.translations['Choose your Buttons'], 'active': true },
        'front': { 'component': 'front', 'title': window.shirtdesigner.translations['Placket'], 'todo': window.shirtdesigner.translations['Choose Placket'], 'active': true },
        'back': { 'component': 'back', 'title': window.shirtdesigner.translations['Back-Design'], 'todo': window.shirtdesigner.translations['Choose Back-Design'], 'active': true },
        'bags': { 'component': 'bags', 'title': window.shirtdesigner.translations['Bags'], 'todo': window.shirtdesigner.translations['Choose Bags'], 'active': true },
        'monogramm': { 'component': 'monogramm', 'extra': window.shirtdesigner.extraPrices['monogramm'], 'title': window.shirtdesigner.translations['Monogram'], 'todo': window.shirtdesigner.translations['4 steps to your monogram:'] + '<br/><br/>' + window.shirtdesigner.translations['1. Enter monogram (max. 3 chars and 3 points)'] + '<br/>' + window.shirtdesigner.translations['2. Select font'] + '<br/>' + window.shirtdesigner.translations['3. Select position'] + '<br/>' + window.shirtdesigner.translations['4. Select yarn color'] + '<br/><br/>' + window.shirtdesigner.translations['If you don`t want to have a monogram, just leave field empty.'], 'active': true },
        'hankerchief': { 'component': 'hankerchief', 'extra': window.shirtdesigner.extraPrices['hankerchief'], 'title': window.shirtdesigner.translations['Hankerchief'], 'todo': window.shirtdesigner.translations['Order the matching handkerchief in your shirt color'], 'active': true },
        'yarncontrast': { 'component': 'yarncontrast', 'extra': window.shirtdesigner.extraPrices['yarncontrast'], 'title': window.shirtdesigner.translations['Yarn Contrast Suture'], 'todo': window.shirtdesigner.translations['Choose a Contrast-Yarn for sutures.'] + '<br/>' + window.shirtdesigner.translations['Note: Neutral means a yarn is chosen according to fabric'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
        'yarnbuttonhole': { 'component': 'yarnbuttonhole', 'extra': window.shirtdesigner.extraPrices['yarnbuttonhole'], 'title': window.shirtdesigner.translations['Yarn Buttonhole'], 'todo': window.shirtdesigner.translations['Choose a Contrast-Yarn for buttonholes'] + '<br/>' + window.shirtdesigner.translations['Note: Neutral means a yarn is chosen according to fabric'], 'active': true },
        'contrastjumper': { 'component': 'contrastjumper', 'title': window.shirtdesigner.translations['Contrast Fabrics'], 'todo': window.shirtdesigner.translations['Do you want to skip contrast fabrics?'], 'active': true },
        'contrast_bs_upper_outside': { 'component': 'contrast_bs_upper_outside', 'extra': window.shirtdesigner.extraPrices['contrast_bs_upper_outside'], 'title': window.shirtdesigner.translations['Upper Button Strip (outside)'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the upper button strip (outside).'], 'active': true },
        'contrast_bs_upper_inside': { 'component': 'contrast_bs_upper_inside', 'extra': window.shirtdesigner.extraPrices['contrast_bs_upper_inside'], 'title': window.shirtdesigner.translations['Upper Button Strip (inside)'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the upper button strip (inside).'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
        'contrast_bs_bottom_outside': { 'component': 'contrast_bs_bottom_outside', 'extra': window.shirtdesigner.extraPrices['contrast_bs_bottom_outside'], 'title': window.shirtdesigner.translations['Lower Button Strip (outside)'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the lower button strip (outside).'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
        'contrast_collar_outside': { 'component': 'contrast_collar_outside', 'extra': window.shirtdesigner.extraPrices['contrast_collar_outside'], 'title': window.shirtdesigner.translations['Collar Outside'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the outer collar'], 'active': true },
        'contrast_collar_bottom': { 'component': 'contrast_collar_bottom', 'extra': window.shirtdesigner.extraPrices['contrast_collar_bottom'], 'title': window.shirtdesigner.translations['Collar Bottom'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the lower collar'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
        'contrast_collar_stand_outer': { 'component': 'contrast_collar_stand_outer', 'extra': window.shirtdesigner.extraPrices['contrast_collar_stand_outer'], 'title': window.shirtdesigner.translations['Collar Outer-Stand'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the outer collar stand'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
        'contrast_collar_stand_inner': { 'component': 'contrast_collar_stand_inner', 'extra': window.shirtdesigner.extraPrices['contrast_collar_stand_inner'], 'title': window.shirtdesigner.translations['Collar Inner-Stand'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the inner collar stand'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
        'contrast_cuff_outside': { 'component': 'contrast_cuff_outside', 'extra': window.shirtdesigner.extraPrices['contrast_cuff_outside'], 'title': window.shirtdesigner.translations['Cuff Outside'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the outer cuff'], 'active': true },
        'contrast_cuff_inside': { 'component': 'contrast_cuff_inside', 'extra': window.shirtdesigner.extraPrices['contrast_cuff_inside'], 'title': window.shirtdesigner.translations['Cuff Inside'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the inner cuff'], 'active': true },
        'contrast_sleeve_buttons_outside': { 'component': 'contrast_sleeve_buttons_outside', 'extra': window.shirtdesigner.extraPrices['contrast_sleeve_buttons_outside'], 'title': window.shirtdesigner.translations['Cuff Outer Button Strip'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the outer button strip (cuff).'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
        'contrast_sleeve_buttons_inside': { 'component': 'contrast_sleeve_buttons_inside', 'extra': window.shirtdesigner.extraPrices['contrast_sleeve_buttons_inside'], 'title': window.shirtdesigner.translations['Cuff Inner Button Strip'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the inner button strip (cuff).'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
        'checkout': { 'component': 'checkout', 'title': window.shirtdesigner.translations['Maße & Kaufen'], 'todo': '', 'active': true }
      },
      selectBoxItems: {
        'fit': [
          { 'ref_number': 'fitted', 'thumb': 'jack/shirt/thumb/fit_fitted.jpg', 'name': window.shirtdesigner.translations['_1Fitted'], 'infotext': window.shirtdesigner.translations['Fit Fitted Description'] },
          { 'ref_number': 'normal', 'thumb': 'jack/shirt/thumb/fit_normal.jpg', 'name': window.shirtdesigner.translations['Normal'], 'infotext': window.shirtdesigner.translations['Fit Normal Description'] },
          { 'ref_number': 'comfort', 'thumb': 'jack/shirt/thumb/fit_comfort.jpg', 'name': window.shirtdesigner.translations['Comfort'], 'infotext': window.shirtdesigner.translations['Fit Comfort Description'] }
        ],
        'lowercut': [
          { 'ref_number': 'curved', 'thumb': 'jack/shirt/thumb/lowercut_curved.jpg', 'name': window.shirtdesigner.translations['Curved'], 'infotext': window.shirtdesigner.translations['Lowercut Curved Description'] },
          { 'ref_number': 'straight', 'thumb': 'jack/shirt/thumb/lowercut_straight.jpg', 'name': window.shirtdesigner.translations['Straight'], 'infotext': window.shirtdesigner.translations['Lowercut Straight Description'] }
        ],
        'sleeve': [
          { 'ref_number': 'long', 'thumb': 'jack/shirt/thumb/sleeve_long.jpg', 'name': window.shirtdesigner.translations['Long'], 'infotext': window.shirtdesigner.translations['Sleeve Long Description'] },
          { 'ref_number': 'short', 'thumb': 'jack/shirt/thumb/sleeve_short.jpg', 'name': window.shirtdesigner.translations['Short'], 'infotext': window.shirtdesigner.translations['Sleeve Short Description'] },
          { 'ref_number': 'shortbar', 'thumb': 'jack/shirt/thumb/sleeve_shortbar.jpg', 'name': window.shirtdesigner.translations['Short with Bar'], 'infotext': window.shirtdesigner.translations['Sleeve Shortbar Description'] }
        ],
        'collar': [
          { 'ref_number': 'kent', 'thumb': 'jack/shirt/thumb/collar_kent.jpg', 'name': window.shirtdesigner.translations['Kent'] },
          { 'ref_number': 'buttondown', 'thumb': 'jack/shirt/thumb/collar_buttondown.jpg', 'name': window.shirtdesigner.translations['Button-Down'] },
          { 'ref_number': 'shark', 'thumb': 'jack/shirt/thumb/collar_shark.jpg', 'name': window.shirtdesigner.translations['Shark'] },
          { 'ref_number': 'kentsmall', 'thumb': 'jack/shirt/thumb/collar_kentsmall.jpg', 'name': window.shirtdesigner.translations['Small Kent'] },
          { 'ref_number': 'buttondownsmall', 'thumb': 'jack/shirt/thumb/collar_buttondownsmall.jpg', 'name': window.shirtdesigner.translations['Small Button-Down'] },
          { 'ref_number': 'sharksmall', 'thumb': 'jack/shirt/thumb/collar_sharksmall.jpg', 'name': window.shirtdesigner.translations['Small Shark'] },
          { 'ref_number': 'tab', 'thumb': 'jack/shirt/thumb/collar_tab.jpg', 'name': window.shirtdesigner.translations['Tab'] },
          { 'ref_number': 'windsor', 'thumb': 'jack/shirt/thumb/collar_windsor.jpg', 'name': window.shirtdesigner.translations['Windsor'] },
          { 'ref_number': 'standup', 'thumb': 'jack/shirt/thumb/collar_standup.jpg', 'name': window.shirtdesigner.translations['Stand-Up'] },
          { 'ref_number': 'london', 'thumb': 'jack/shirt/thumb/collar_london.jpg', 'name': window.shirtdesigner.translations['London'] },
          { 'ref_number': 'napolishark', 'thumb': 'jack/shirt/thumb/collar_napolishark.jpg', 'name': window.shirtdesigner.translations['Napoli Shark'] },
          { 'ref_number': 'smoking', 'thumb': 'jack/shirt/thumb/collar_smoking.jpg', 'name': window.shirtdesigner.translations['Smoking'] }
        ],
        'cuff': [
          { 'ref_number': 'squaresingle', 'thumb': 'jack/shirt/thumb/cuff_squaresingle.jpg', 'name': window.shirtdesigner.translations['Square 1-Button'] },
          { 'ref_number': 'squaredouble', 'thumb': 'jack/shirt/thumb/cuff_squaredouble.jpg', 'name': window.shirtdesigner.translations['Square 2-Button'] },
          { 'ref_number': 'squaretripple', 'thumb': 'jack/shirt/thumb/cuff_squaretripple.jpg', 'name': window.shirtdesigner.translations['Square 3-Button'] },
          { 'ref_number': 'roundsingle', 'thumb': 'jack/shirt/thumb/cuff_roundsingle.jpg', 'name': window.shirtdesigner.translations['Round 1-Button'] },
          { 'ref_number': 'rounddouble', 'thumb': 'jack/shirt/thumb/cuff_rounddouble.jpg', 'name': window.shirtdesigner.translations['Round 2-Button'] },
          { 'ref_number': 'roundenv', 'thumb': 'jack/shirt/thumb/cuff_roundenv.jpg', 'name': window.shirtdesigner.translations['Round Envelope'] },
          { 'ref_number': 'straightsingle', 'thumb': 'jack/shirt/thumb/cuff_straightsingle.jpg', 'name': window.shirtdesigner.translations['Straigth 1-Button'] },
          { 'ref_number': 'straightdouble', 'thumb': 'jack/shirt/thumb/cuff_straightdouble.jpg', 'name': window.shirtdesigner.translations['Straigth 2-Button'] }
        ],
        'buttons': [],
        'front': [
          { 'ref_number': 'normal', 'thumb': 'jack/shirt/thumb/front_normal.jpg', 'name': window.shirtdesigner.translations['Normal'] },
          { 'ref_number': 'sewed', 'thumb': 'jack/shirt/thumb/front_sewed.jpg', 'name': window.shirtdesigner.translations['Sewed'] },
          { 'ref_number': 'hidden', 'thumb': 'jack/shirt/thumb/front_hidden.jpg', 'name': window.shirtdesigner.translations['Hidden'] }
        ],
        'back': [
          { 'ref_number': 'flat', 'thumb': 'jack/shirt/thumb/back_flat.jpg', 'name': window.shirtdesigner.translations['_1Flat'] },
          { 'ref_number': 'middle', 'thumb': 'jack/shirt/thumb/back_middle.jpg', 'name': window.shirtdesigner.translations['Middle'] },
          { 'ref_number': 'sidedart', 'thumb': 'jack/shirt/thumb/back_sidedart.jpg', 'name': window.shirtdesigner.translations['Side-Dart'] }
        ],
        'bags': [
          { 'ref_number': 'none', 'thumb': 'upload/image/dummy_product_small.jpg', 'name': window.shirtdesigner.translations['None'] },
          { 'ref_number': 'ustyle', 'thumb': 'jack/shirt/thumb/bags_ustyle.jpg', 'name': window.shirtdesigner.translations['U-Style'] },
          { 'ref_number': 'vstyle', 'thumb': 'jack/shirt/thumb/bags_vstyle.jpg', 'name': window.shirtdesigner.translations['V-Style'] }
        ],
        'monogramm': [],
        'hankerchief': [],
        'yarncontrast': [],
        'yarnbuttonhole': [],
        'contrastjumper': [],
        'contrast_bs_upper_outside': [],
        'contrast_bs_upper_inside': [],
        'contrast_bs_bottom_outside': [],
        'contrast_collar_outside': [],
        'contrast_collar_bottom': [],
        'contrast_collar_stand_outer': [],
        'contrast_collar_stand_inner': [],
        'contrast_cuff_outside': [],
        'contrast_cuff_inside': [],
        'contrast_sleeve_buttons_outside': [],
        'contrast_sleeve_buttons_inside': []
      },
      'summary': [],
      'currentStep': '',
      'currentPrice': '',
      'showModal': false,
      'currentExtraPrices': {},
      'muster1': JSON.parse(localStorage.getItem('muster1')),
      'muster2': JSON.parse(localStorage.getItem('muster2')),
      'muster3': JSON.parse(localStorage.getItem('muster3')),
      'muster4': JSON.parse(localStorage.getItem('muster4'))
    }
  },
  created: function () {
    /*global localStorage: false */
    var changedStep = 0
    var c = localStorage.getItem('currentViewShirt')
    if (localStorage.getItem('shirtIsTopseller') > 0) {
      localStorage.setItem('shirtIsTopseller', 0)
      changedStep = this.views.length - 2
    } else if (localStorage.getItem('shirt_configure_id') > 0) {
      this.personal['configure_id'] = localStorage.getItem('shirt_configure_id')
      localStorage.setItem('shirt_configure_id', 0)
      changedStep = this.views.length - 1
    } else {
      for (var j = 0; j < this.personal.length; j++) {
        if (this.personal[j] !== this.defaults[j]) {
          changedStep = j
        }
      }
      if (c > changedStep) {
        changedStep = c
      }
    }
    this.personal = this.getPersonalData()
    if (c) {
      for (var i = 1; i <= changedStep; i++) {
        this.addStep(i)
        this.updateSteps(i - 1)
      }
      this.gotoStep(c)
    }

    if (this.isloggedin !== 'false') {
      jQuery.post(this.baseurl + 'designer/ajax/loadSession', {type: 'shirt'}, function (data) {
        this.session = JSON.parse(data)
        this.design = this.session.configuration
        this.loadDesignData(this.design)
        this.updatePrice()
      }.bind(this))
    }
    jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getButtonList', { target: 'button', type: 'shirt' }, function (data) {
      this.buttons = data
      this.updatePrice()
    }.bind(this))
    this.setMobileTitle()
    this.updateMonogrammPosition(this.personal['monopos'])
  },
  computed: {
    monogrammUrl: function () { return window.shirtdesigner['monogrammImageURL'] + '/color/' + this.personal['monogramm-color'] + '/text/' + this.personal['monogramm'] + '/pos/' + this.personal['monopos'] + '.png' },
    frontUrl: function () { return window.shirtdesigner['compositeUrl'] + '/cps/front/texture/' + this.personal['fabric'] + '/mask/front_sewed.png' },
    buttonStripeUrl: function () { return window.shirtdesigner['compositeUrl'] + '/cps/front/texture/' + this.personal['contrast_bs_upper_outside'] + '/mask/button_stripe_' + this.personal['lowercut'] + '.png' },
    cuffUrl: function () { return window.shirtdesigner['compositeUrl'] + '/cps/cuff/texture/' + (this.personal['contrast_cuff_outside'] === 'none' ? this.personal['fabric'] : this.personal['contrast_cuff_outside']) + '/mask/cuff_' + this.personal['cuff'] + '.png' },
    cuffInnerUrl: function () { return window.shirtdesigner['compositeUrl'] + '/cps/cuffinner/texture/' + (this.personal['cuff'] === 'roundenv' ? (this.personal['contrast_cuff_outside'] === 'none' ? this.personal['fabric'] : this.personal['contrast_cuff_outside']) : (this.personal['contrast_cuff_inside'] === 'none' ? this.personal['fabric'] : this.personal['contrast_cuff_inside'])) + '/mask/mask_cuff_inner_' + this.personal['cuff'] + '.png' },
    fitUrl: function () { return window.shirtdesigner['compositeUrl'] + '/cps/fit/texture/' + this.personal['fabric'] + '/mask/fit_' + this.personal['fit'] + '_' + this.personal['lowercut'] + '.png' },
    buttonsFrontUrl: function () { return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['button-color'] + '/img/mask_buttons_front.png' },
    sleeveUrl: function () { return window.shirtdesigner['compositeUrl'] + '/cps/sleeve/texture/' + this.personal['fabric'] + '/mask/sleeve_' + this.personal['sleeve'] + '.png' },
    buttonsCuffUrl: function () { return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['button-color'] + '/img/mask_buttons_cuff_' + this.personal['cuff'] + '.png' },
    buttonsCollarUrl: function () { return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['button-color'] + '/img/mask_buttons_collar_' + this.personal['collar'] + '.png' },
    yarnFrontUrl: function () { return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['yarnbuttonhole'] + '/img/mask_yarn_front.png' },
    yarnCuffUrl: function () { return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['yarnbuttonhole'] + '/img/mask_yarn_cuff_' + this.personal['cuff'] + '.png' },
    yarnCollarUrl: function () { return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['yarnbuttonhole'] + '/img/mask_yarn_collar_' + this.personal['collar'] + '.png' },
    collarWingsUrl: function () { return window.shirtdesigner['compositeUrl'] + '/cps/collarwing/texture/' + (this.personal['contrast_collar_outside'] === 'none' ? this.personal['fabric'] : this.personal['contrast_collar_outside']) + '/mask/mask_collar_wings_' + this.personal['collar'] + '.png' },
    collarStandUrl: function () { return window.shirtdesigner['compositeUrl'] + '/cps/collarinnerback/texture/' + this.personal['fabric'] + '/mask/mask_collar_inner_back.png' },
    collarInnerStandUrl: function () { return window.shirtdesigner['compositeUrl'] + '/cps/collarinnerstand/texture/' + (this.personal['contrast_collar_stand_inner'] === 'none' ? this.personal['fabric'] : this.personal['contrast_collar_stand_inner']) + '/mask/mask_collar_inner_stand.png' },
    collarInnerBackUrl: function () { return window.shirtdesigner['compositeUrl'] + '/cps/collarstand/texture/' + (this.personal['contrast_collar_stand_outer'] === 'none' ? this.personal['fabric'] : this.personal['contrast_collar_stand_outer']) + '/mask/mask_collar_stand_' + this.personal['collar'] + '.png' },
    bagsUrl: function () { return window.shirtdesigner['compositeUrl'] + '/cps/bags/texture/' + this.personal['fabric'] + '/mask/bags_' + this.personal['bags'] + '_' + this.personal['bagsposition'] + '.png' }
  },
  methods: {
    touchhover: function (event) {
      jQuery('#' + event.currentTarget.id).addClass('hover_effect')
    },
    touchhoverout: function (event) {
      jQuery('#' + event.currentTarget.id).delay(300).removeClass('hover_effect')
    },
    nextStep: function () {
      if (this.count++ >= this.views.length - 1) {
        this.count = 0
      }
      var contents = this.views[this.count]
      var selectBox = this.selectBoxes[contents]
      if (this.count >= 1) {
        this.updateSteps(this.count - 1)
      }
      if (!selectBox.active) {
        this.updateSteps(this.count)
        this.addStep(this.count)
        this.nextStep()
      }
      this.setView(this.count)
      this.loadContents(this.count)
      this.addStep(this.count)
      this.setMobileTitle()
      this.scrollStepsOnMobile(this.count)
    },
    prevStep: function () {
      if (this.count > 0) {
        this.count--
      }
      if (this.count >= -1) {
        this.updateSteps(this.count + 1)
      }
      if (this.count > 0) {
        var contents = this.views[this.count]
        var selectBox = this.selectBoxes[contents]
        if (!selectBox.active) {
          this.updateSteps(this.count)
          if (this.count > 0) {
            this.prevStep()
          }
        }
      }
      this.setView(this.count)
      this.loadContents(this.count)
      this.addStep(this.count)
      this.setMobileTitle()
      this.scrollStepsOnMobile(this.count)
    },
    addStep: function (c) {
      if (this.steps.length <= c && c < 26 && this.selectBoxes[this.views[c]].title !== '') {
        this.steps.push(this.selectBoxes[this.views[c]].title)
        this.runDesignJQuery()
      }
    },
    updateSteps: function (c) {
      if (c >= 0 && c <= 26) {
        var stepTitle

        if (c === 0 || this.views[c] === 'fabric') {
          stepTitle = window.shirtdesigner.translations['Fabric']
        } else {
          stepTitle = this.selectBoxes[this.views[c]].title.trim()
        }
        switch (c) {
          case 0:
          case 15:
          case 16:
          case 17:
          case 18:
          case 19:
          case 20:
          case 21:
          case 22:
          case 23:
          case 24:
          case 25:
            jQuery.getJSON(window.shirtdesigner['baseurl'] + 'designer/ajax/getFabricBySku', { sku: this.personal[this.views[c]], type: 'shirt' }).done(function (data) {
              this.stepValue[c] = data.title
              if (c === 0) {
                window.shirtdesigner.extraPrices['fabric'] = data.price
                this.updatePrice()
              }
              if (this.stepValue[c]) {
                stepTitle = stepTitle.trim() + ': ' + this.stepValue[c]
              } else {
                stepTitle = stepTitle.trim()
              }
              if (stepTitle !== '' && c !== 26 && c !== 14) {
                this.steps[c] = stepTitle
                this.steps.push('x')
                this.steps.pop()
              }
            }.bind(this))
            break
          case 6:
            jQuery.getJSON(window.shirtdesigner['baseurl'] + 'designer/ajax/getButtonBySku', { sku: this.personal[this.views[c]] }).done(function (data) {
              this.stepValue[c] = data.title
              if (this.stepValue[c]) {
                stepTitle = stepTitle.trim() + ': ' + this.stepValue[c]
              } else {
                stepTitle = stepTitle.trim()
              }
              if (stepTitle !== '' && c !== 26) {
                this.steps[c] = stepTitle
                this.steps.push('x')
                this.steps.pop()
              }
            }.bind(this))
            break
          case 12:
          case 13:
            jQuery.getJSON(window.shirtdesigner['baseurl'] + 'designer/ajax/getYarnBySku', { sku: this.personal[this.views[c]] }).done(function (data) {
              this.stepValue[c] = data.title
              if (this.stepValue[c]) {
                stepTitle = stepTitle.trim() + ': ' + this.stepValue[c]
              } else {
                stepTitle = stepTitle.trim()
              }
              if (stepTitle !== '' && c !== 26) {
                this.steps[c] = stepTitle
                this.steps.push('x')
                this.steps.pop()
              }
            }.bind(this))
            break
          default:
            this.stepValue[c] = this.personal[this.views[c]]
            if (this.stepValue[c] in window.shirtdesigner.translations) {
              this.stepValue[c] = window.shirtdesigner.translations[this.stepValue[c]].trim()
            }
            if ((c === 10 || c === 11) && this.stepValue[c] === 'keine') {
              this.stepValue[c] = 'keines'
            }
            var contents = this.views[c]
            var selectBox = this.selectBoxes[contents]
            if (c === 0 || c === '0') {
              selectBox = { 'component': 'fabric', 'title': window.shirtdesigner.translations['Fabric'], 'todo': window.shirtdesigner.translations['Choose from these fabrics.'], 'active': true }
            }
            if (this.stepValue[c] && selectBox.active) {
              stepTitle = stepTitle.trim() + ': ' + this.stepValue[c]
            } else {
              stepTitle = stepTitle.trim()
            }
            if (stepTitle !== '' && c !== 26) {
              this.steps[c] = stepTitle
              this.steps.push('x')
              this.steps.pop()
              this.runDesignJQuery()
            }
        }
      }
    },
    gotoStep: function (c) {
      for (let i = 0; i <= c; i++) {
        this.updateSteps(i)
      }
      var contents = this.views[c]
      var selectBox = this.selectBoxes[contents]
      if (typeof selectBox !== 'undefined') {
        if (selectBox.active) {
          this.updateSteps(this.count)
          this.setView(c)
          this.count = c
          if (c > 0) {
            this.loadContents(c)
          }
          this.setMobileTitle()
        }
      } else {
        this.updateSteps(this.count)
        this.setView(c)
        this.count = c
        if (c > 0) {
          this.loadContents(c)
        }
        this.setMobileTitle()
      }
      this.scrollStepsOnMobile(c)
    },
    setMobileTitle: function () {
      if (this.selectBoxes[this.views[this.count]]) {
        this.currentStep = this.selectBoxes[this.views[this.count]].title
      } else {
        this.currentStep = window.shirtdesigner.translations['Fabric']
      }
      if (this.currentExtraPrices[this.views[this.count]] && Number(this.currentExtraPrices[this.views[this.count]]) > 0) {
        this.currentPrice = Number(this.currentExtraPrices[this.views[this.count]]).toFixed(2)
      } else {
        this.currentPrice = ''
      }
    },
    setView: function (c) {
      var contents = this.views[c]
      localStorage.setItem('currentViewShirt', c)
      const oldView = this.currentView
      switch (contents) {
        case 'fabric':
          this.currentView = 'fabric'
          break
        case 'buttons':
          this.currentView = 'buttons'
          break
        case 'collar':
          this.currentView = 'collar'
          break
        case 'cuff':
          this.currentView = 'cuff'
          break
        case 'bags':
          this.currentView = 'bags'
          break
        case 'monogramm':
          this.currentView = 'monogramm'
          break
        case 'hankerchief':
          this.currentView = 'hankerchief'
          break
        case 'yarncontrast':
        case 'yarnbuttonhole':
          this.currentView = 'yarnbuttonhole'
          break
        case 'contrastjumper':
          this.currentView = 'contrastjumper'
          break
        case 'contrast_collar_outside':
        case 'contrast_collar_bottom':
        case 'contrast_collar_stand_outer':
        case 'contrast_collar_stand_inner':
        case 'contrast_cuff_outside':
        case 'contrast_cuff_inside':
        case 'contrast_sleeve_buttons_outside':
        case 'contrast_sleeve_buttons_inside':
        case 'contrast_bs_upper_outside':
        case 'contrast_bs_upper_inside':
        case 'contrast_bs_bottom_outside':
          this.currentView = 'ContrastCollarOutside'
          break
        case 'checkout':
          this.currentView = 'checkout'
          break
        default:
          this.currentView = 'fit'
          break
      }
      this.isActive = this.personal[contents]
      if (this.currentView === oldView) {
        // force reload!
        this.currentView = ''
        this.$nextTick(function () {
          this.currentView = oldView
        })
      }
    },
    getPersonalData: function () {
      var result = {}
      var data = this.personal
      if (data !== undefined) {
        var keys = Object.keys(data)
        var i = 0
        var key
        while (keys[i]) {
          key = keys[i]
          if (key === 'topseller') {
            result[key] = ''
          } else {
            result[key] = ((localStorage.getItem(key)) ? JSON.parse(localStorage[key]) : data[key])
          }
          this.implementDependencies(key, result[key])
          i++
        }
      }
      return result
    },
    resetConfig: function () {
      var data = this.personal
      var keys = Object.keys(data)
      var key
      var i = 0
      window.shirtdesigner.swal({
        title: window.shirtdesigner.translations['Are you sure?'],
        text: window.shirtdesigner.translations['Your current design will be reseted.'],
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0092a9',
        cancelButtonText: window.shirtdesigner.translations['Cancel'],
        confirmButtonText: window.shirtdesigner.translations['Yes, reset it!'],
        closeOnConfirm: true
      }, function (isConfirm) {
        if (isConfirm) {
          while (keys[i]) {
            key = keys[i]
            this.personal[key] = this.defaults[key]
            if (localStorage.getItem(key)) {
              localStorage.removeItem(key)
            }
            i++
          }
          localStorage.setItem('currentViewShirt', 0)
          this.count = 0
          this.gotoStep(0)
          jQuery.post(this.baseurl + 'designer/ajax/reset', { type: 'shirt' })

          this.designName = 'Mein Design'
          this.steps = [window.shirtdesigner.translations['Fabric']]
          this.updatePrice()
        }
      }.bind(this))
    },
    addToCart: function () {
      var addToCartURL = window.shirtdesigner['baseurl'] + 'designer/ajax/addToCart'
      var serialized = {
        shirt: this.getPersonalData(),
        measurement: { entity: jQuery('#shirtdesigner-measurement-select').val() }
      }
      jQuery.post(addToCartURL, serialized, function (data) {
        this.selectItems = JSON.parse(data)
        this.addToCartText = this.selectItems.checkoutText
      }.bind(this))
    },
    showSummary: function () {
      this.showModal = true
    },
    loadContents: function (c) {
      var contents = this.views[c]
      this.selectBox = this.selectBoxes[contents]
      this.selectItems = []
      switch (contents) {
        case 'buttons':
          jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getButtonBySku', { sku: this.personal['buttons'] }, function (data) {
            var currentButton = data
            this.buttonsection = currentButton.section
            jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getButtonList', { target: 'button', type: 'shirt', section: currentButton.section }, function (finalData) {
              if (c === this.count) {
                this.selectItems = finalData
              }
            }.bind(this))
          }.bind(this))
          break
        case 'monogramm':
        case 'yarncontrast':
        case 'yarnbuttonhole':
          jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getYarnList', { type: 'all' }, function (data) {
            data.unshift({'entity_id': '0', 'ref_number': 'none', 'name': 'Neutral', 'infotext': 'neutral', 'quality': 'classic', 'thumb': 'upload/image/dummy_product_small.jpg', 'color_code': 'neutral', 'pattern': '', 'weave': '', 'composition': '', 'season': '', 'occasion': '', 'yarn': '', 'weight': '', 'new': '0', 'topseller': '0', 'retail_title': '', 'retail_id': '', 'price': '0', 'special_price': '0'})
            this.fabrics = data
          }.bind(this))
          break
        case 'contrast_collar_outside':
        case 'contrast_collar_bottom':
        case 'contrast_collar_stand_outer':
        case 'contrast_collar_stand_inner':
        case 'contrast_cuff_outside':
        case 'contrast_cuff_inside':
        case 'contrast_sleeve_buttons_inside':
        case 'contrast_sleeve_buttons_outside':
        case 'contrast_bs_upper_outside':
        case 'contrast_bs_upper_inside':
        case 'contrast_bs_bottom_outside':
          jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getFabricList', { type: 'shirt', basefabricsku: this.personal['fabric'] }, function (data) {
            data.unshift({'entity_id': '0', 'ref_number': 'none', 'name': 'Neutral', 'infotext': 'neutral', 'quality': 'classic', 'thumb': 'upload/image/dummy_product_small.jpg', 'color': 'neutral', 'material': '', 'pattern': '', 'weave': '', 'composition': '', 'season': '', 'occasion': '', 'yarn': '', 'weight': '', 'new': '0', 'topseller': '0', 'retail_title': '', 'retail_id': '', 'price': '49.90', 'special_price': '0'})
            this.fabrics = data
          }.bind(this))
          break
        case 'fabric':
          this.selectItems = []
          break
        default:
          this.selectItems = this.selectBoxItems[contents]
      }
      this.isActive = this.personal[contents]
    },
    loadDesignData: function (data) {
      if (data !== undefined && data.name !== null) {
        this.designName = (data.name ? data.name : 'Mein Design')
        var keys = Object.keys(this.personal)
        var i = 0
        var key
        while (keys[i]) {
          key = keys[i]
          this.personal[key] = (data[key] ? data[key] : this.defaults[key])
          this.updateSteps(i)
          i++
        }
        this.updatePrice()
        this.runDesignJQuery()
      }
    },
    updatePrice: function () {
      this.price = (window.shirtdesigner.extraPrices['fabric'] > 0 ? window.shirtdesigner.extraPrices['fabric'] : window.shirtdesigner['priceClassic'])
      this.price = (Number(this.price)).toFixed(2)

      var buttonSku = this.personal['buttons']
      var updateButtonPrice = jQuery.grep(this.buttons, function (e) { return e.sku === buttonSku })[0]

      if (typeof updateButtonPrice !== 'undefined') {
        this.price = (Number(this.price) + Number(updateButtonPrice.price)).toFixed(2)
        this.currentExtraPrices['buttons'] = Number(updateButtonPrice.price)
      } else {
        this.currentExtraPrices['buttons'] = 0
      }

      if (this.personal['monogramm'] !== 'no_monogramm' && this.personal['monogramm'].length > 0) {
        this.price = (Number(this.price) + Number(window.shirtdesigner.extraPrices['monogramm'])).toFixed(2)
        this.currentExtraPrices['monogramm'] = Number(window.shirtdesigner.extraPrices['monogramm'])
      } else {
        this.currentExtraPrices['monogramm'] = 0
      }

      if (this.personal['yarncontrast'] !== 'neutral' && this.personal['yarncontrast'] !== '') {
        this.price = (Number(this.price) + Number(window.shirtdesigner.extraPrices['yarncontrast'])).toFixed(2)
        this.currentExtraPrices['yarncontrast'] = Number(window.shirtdesigner.extraPrices['yarncontrast'])
      } else {
        this.currentExtraPrices['yarncontrast'] = 0
      }

      if (this.personal['yarnbuttonhole'] !== 'neutral' && this.personal['yarnbuttonhole'] !== '') {
        this.price = (Number(this.price) + Number(window.shirtdesigner.extraPrices['yarnbuttonhole'])).toFixed(2)
        this.currentExtraPrices['yarnbuttonhole'] = Number(window.shirtdesigner.extraPrices['yarnbuttonhole'])
      } else {
        this.currentExtraPrices['yarnbuttonhole'] = 0
      }

      var extras = [ 'contrast_cuff_outside', 'contrast_cuff_inside', 'contrast_collar_outside', 'contrast_collar_bottom', 'contrast_collar_stand_outer', 'contrast_collar_stand_inner', 'contrast_sleeve_buttons_outside', 'contrast_sleeve_buttons_inside', 'contrast_bs_upper_outside', 'contrast_bs_upper_inside', 'contrast_bs_bottom_outside' ]
      for (var i = 0; i < extras.length; i++) {
        var s = extras[i]
        if (this.personal[s] !== 'none' && this.personal[s] !== this.personal['fabric']) {
          this.price = (Number(this.price) + Number(window.shirtdesigner.extraPrices[s])).toFixed(2)
          this.currentExtraPrices[s] = Number(window.shirtdesigner.extraPrices[s])
        } else {
          this.currentExtraPrices[s] = 0
        }
      }
      if (this.personal['contrast_collar_outside'] !== 'none' && this.personal['contrast_collar_outside'] !== this.personal['fabric'] && this.personal['contrast_collar_outside'] === this.personal['contrast_collar_bottom'] && this.personal['contrast_collar_outside'] === this.personal['contrast_collar_stand_outer'] && this.personal['contrast_collar_outside'] === this.personal['contrast_collar_stand_inner']) {
        this.price = (Number(this.price) - 5).toFixed(2)
      }
      if (this.personal['contrast_cuff_outside'] !== 'none' && this.personal['contrast_cuff_outside'] !== this.personal['fabric'] && this.personal['contrast_cuff_outside'] === this.personal['contrast_cuff_inside'] && this.personal['contrast_cuff_outside'] === this.personal['contrast_sleeve_buttons_outside'] && this.personal['contrast_cuff_outside'] === this.personal['contrast_sleeve_buttons_inside']) {
        this.price = (Number(this.price) - 5).toFixed(2)
      }
      if (this.personal['hankerchief'] === 'yes') {
        this.price = (Number(this.price) + Number(window.shirtdesigner.extraPrices['hankerchief'])).toFixed(2)
        this.currentExtraPrices['hankerchief'] = Number(window.shirtdesigner.extraPrices['hankerchief'])
      } else {
        this.currentExtraPrices['hankerchief'] = 0
      }
      if (this.personal['outsize'] !== 'none') {
        this.price = (Number(this.price) + Number(this.priceExtra)).toFixed(2)
      }
    },
    saveDesign: function (event) {
      var saveDesignURL = this.baseurl + 'designer/ajax/saveDesign'
      if (this.personal) {
        var serialized = { type: 'shirt', name: this.designName, shirt: this.personal }
        jQuery.post(saveDesignURL, serialized, function (data) {
          var applyMsg = JSON.parse(data)
          this.msg = applyMsg
          jQuery('#messages').fadeIn('slow').delay(4000).fadeOut('slow')
        }.bind(this))
      }
    },
    clearViewCount: function () {
      if (localStorage.getItem('currentViewShirt')) {
        localStorage.removeItem('currentViewShirt')
      }
      var data = this.personal
      var keys = Object.keys(data)
      var key
      var i = 0
      while (keys[i]) {
        key = keys[i]
        this.personal[key] = this.defaults[key]
        if (localStorage.getItem(key)) {
          localStorage.removeItem(key)
        }
        i++
      }
      jQuery('#product_addtocart_form').submit()
    },
    setSelectStatus: function (component, value) {
      if (component !== undefined) {
        this.selectBoxes[component].active = value
        if (value === false) {
          this.personal[component] = this.defaults[component]
        }
        this.updatePrice()
      }
    },
    implementDependencies: function (component, value) {
      switch (component) {
        case 'sleeve':
          if (value === 'short' || value === 'shortbar') {
            this.sleevesShort = true
            this.setSelectStatus('cuff', false)
            this.setSelectStatus('contrast_cuff_outside', false)
            this.setSelectStatus('contrast_cuff_inside', false)
            this.setSelectStatus('contrast_sleeve_buttons_outside', false)
            this.setSelectStatus('contrast_sleeve_buttons_inside', false)
          } else {
            this.sleevesShort = false
            this.setSelectStatus('cuff', true)
            this.setSelectStatus('contrast_cuff_outside', true)
            this.setSelectStatus('contrast_cuff_inside', true)
            this.setSelectStatus('contrast_sleeve_buttons_outside', true)
            this.setSelectStatus('contrast_sleeve_buttons_inside', true)
          }
          break
        /* case 'front':
          if (value === 'sewed') {
            this.setSelectStatus('contrast_bs_upper_inside', true)
            this.setSelectStatus('contrast_bs_bottom_outside', true)
          } else {
            this.setSelectStatus('contrast_bs_upper_inside', false)
            this.setSelectStatus('contrast_bs_bottom_outside', false)
          }
          break */
        case 'cuff':
          if (value === 'roundenv' || this.sleevesShort) {
            this.setSelectStatus('contrast_cuff_inside', false)
          } else {
            this.setSelectStatus('contrast_cuff_inside', true)
          }
          break
        case 'collar':
          if (value === 'standup') {
            this.setSelectStatus('contrast_collar_outside', false)
            this.setSelectStatus('contrast_collar_bottom', false)
          } else {
            this.setSelectStatus('contrast_collar_outside', true)
            this.setSelectStatus('contrast_collar_bottom', true)
          }
          break
      }
    },
    updateMonogrammPosition: function (pos) {
      jQuery(document).ready(function () {
        switch (pos) {
          case 'waistleft' :
            jQuery('.img-monogramm').css('top', '280px')
            jQuery('.img-monogramm').css('left', '195px')
            break
          case 'waistright' :
            jQuery('.img-monogramm').css('top', '280px')
            jQuery('.img-monogramm').css('left', '85px')
            break
          case 'cuffleft' :
            jQuery('.img-monogramm').css('top', '305px')
            jQuery('.img-monogramm').css('left', '255px')
            break
          case 'cuffright' :
            jQuery('.img-monogramm').css('top', '298px')
            jQuery('.img-monogramm').css('left', '35px')
            break
          case 'collarleft' :
            jQuery('.img-monogramm').css('top', '32px')
            jQuery('.img-monogramm').css('left', '165px')
            break
          case 'collarright' :
            jQuery('.img-monogramm').css('top', '32px')
            jQuery('.img-monogramm').css('left', '115px')
            break
          case 'pocketleft' :
            jQuery('.img-monogramm').css('top', '170px')
            jQuery('.img-monogramm').css('left', '195px')
            break
          case 'pocketright' :
            jQuery('.img-monogramm').css('top', '170px')
            jQuery('.img-monogramm').css('left', '85px')
            break
        }
      })
    },
    runDesignJQuery: function () {
      if (jQuery(window).width() > 767) {
        jQuery('.preview-col, .select-col, .infobox').css('height', 'auto')
        if (jQuery('.select-col').outerHeight() > jQuery('.infobox').outerHeight()) {
          jQuery('.preview-col, #konfigurator .select-col, .infobox').css('height', jQuery('.select-col').outerHeight() + jQuery('.top-step-name').outerHeight() + 30)
        } else {
          jQuery('.preview-col, #konfigurator .select-col, .infobox').css('height', jQuery('.infobox').outerHeight() + jQuery('.top-step-name').outerHeight() + 30)
        }
      }
    },
    scrollStepsOnMobile: function (number) {
      if (jQuery(window).width() < 768) {
        jQuery('html, body').animate({scrollTop: 150}, 'slow')
      }
      if (jQuery(window).width() < 768 && jQuery('#' + number).length > 0) {
        jQuery('.step').animate({
          scrollLeft: jQuery('.step').scrollLeft() + jQuery('#' + number).position().left
        }, 200)
      }
    }
  },
  events: {
    getFabricData: function (event) {
      var selectorId = event.currentTarget.id
      window.shirtdesigner.extraPrices['fabric'] = event.currentTarget.dataset.price
      if (selectorId !== '') {
        jQuery.getJSON(window.shirtdesigner['baseurl'] + 'designer/ajax/getList', { target: 'fabric', qlty: selectorId, type: 'shirt' }, function (data) {
          this.fabrics = data
        }.bind(this))
      }
    },
    updatePersonalData: function (data) {
      if (data[0].length && data[1] !== undefined) {
        localStorage.setItem(data[0], JSON.stringify(data[1]))
        this.personal[data[0]] = data[1]
        this.implementDependencies(data[0], data[1])
        this.updatePrice()
        this.setMobileTitle()
        this.updateSteps(this.count)
      }
    },
    runDesignJQuery: function () {
      this.runDesignJQuery()
    },
    setMsg: function (msg) {
      this.flash = msg
      jQuery('#flash').fadeIn('slow').delay(4000).fadeOut('slow')
    },
    updateMonoPosition: function (pos) {
      this.updateMonogrammPosition(pos)
    },
    jumpTo: function (page) {
      if (page === 'last') {
        this.gotoStep(this.views.length - 1)
      } else if (page === 'contrast') {
        this.gotoStep(15)
      }
    },
    setSwatch: function (object) {
      this[object.key] = object.value
    },
    mainCheckDesign: function () {
      var $this = this
      setTimeout(function () {
        $this.runDesignJQuery()
      }, 500)
    }
  },
  watch: {
    steps: function () {
      this.runDesignJQuery()
    }
  },
  ready: function () {
    this.runDesignJQuery()
    /* this.$nextTick(function () {
    var btn = document.getElementById('all-prices')
      if (btn) {
        btn.click()
      }
    })*/
  }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// App.vue?5d75e138